module.exports = __webpack_public_path__ + "static/media/pic4.13c2ab8d.jpg";